module.exports = __webpack_public_path__ + "static/media/rosaparks-mural-interactive.4883e8e6.svg";